import { Component, OnInit, inject, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { InicioService } from '../../services/inicio.service';
import { PlanificacionService } from '../../services/planificacion.service';
import { ProgramacionComponent } from "./programacion/programacion.component";
import { ModalComponent } from '../modal/modal.component';

@Component({
  selector: 'app-planificacion',
  standalone: true,
  imports: [CommonModule, ProgramacionComponent, ModalComponent],
  templateUrl: './planificacion.component.html',
  styleUrl: './planificacion.component.css'
})
export class PlanificacionComponent implements OnInit{
  @ViewChild(ModalComponent) mdl!: ModalComponent;
  rutas =  inject(Router);
  private srvLogin = inject(InicioService);
  private servicios = inject(PlanificacionService);
  years: number[] = [];
  selectedYear: number = 0;
  user: any;
  resultado: any = [];
  errorMessage: string = '';
  isProgramacion: boolean = false;
  validador: boolean = true;

  titulo!: string;
  tipo_color!: string;
  letra_color!: string;
  mensaje!: string;

  permissions = {
    crearCentral: false,
    editarCentral: false,
    verCentral: false,
    crearAmbito: false,
    editarAmbito: false,
    verAmbito: false,
    crearRegional: false,
    editarRegional: false,
    verRegional: false,
    crearProgramacion: false,
    editarProgramacion: false,
    verProgramacion: false,
  }

  //constructor(private servicios: PlanificacionService) { }

  ngOnInit(): void {
    this.getFullYear();
    this.srvLogin.user$.subscribe(user => {
      this.user = user;
      this.fillPermissions();
    });
  }

  ngAfterViewInit(): void {
    this.planificacion(this.user.id_institucional.toString()!, this.selectedYear.toString());
  }

  fillPermissions(){
    let menu = this.user.menu.map((val:any) => val.id_menu)
    console.log('Prueba menu: ',menu)
    this.permissions = {
      crearCentral: (menu?.find((element:any) => element == 27))? true : false,
      editarCentral: (menu?.find((element:any) => element == 28))? true : false,
      verCentral: (menu?.find((element:any) => element == 39))? true : false,

      crearAmbito: (menu?.find((element:any) => element == 32))? true : false,
      editarAmbito: (menu?.find((element:any) => element == 33))? true : false,
      verAmbito: (menu?.find((element:any) => element == 41))? true : false,

      crearRegional: (menu?.find((element:any) => element == 30))? true : false,
      editarRegional: (menu?.find((element:any) => element == 31))? true : false,
      verRegional: (menu?.find((element:any) => element == 40))? true : false,

      crearProgramacion: (menu?.find((element:any) => element == 42))? true : false,
      editarProgramacion: (menu?.find((element:any) => element == 43))? true : false,
      verProgramacion: (menu?.find((element:any) => element == 44))? true : false,
    }
  }

  planificacion(id: string, year: string){
    this.mdl.cargando();
    this.servicios.planificacion(id, year).subscribe({
      next: (rs) => {
        this.mdl.cerrar();
        this.resultado = rs.data;
        if(rs.data.total_meta_central == null && rs.data.total_meta_ambito == null && rs.data.total_meta_regional == null) {
          this.validador = false;
        }else{
          this.validador = true;
        }
        if(!this.validador){
          this.titulo = '!ADVERTENCIA¡';
          this.tipo_color = 'warning';
          this.letra_color = 'dark';
          this.mensaje = `Aun no se han asignado metas para este año (${year}).`;
          this.mdl.alerta();
        }
        //console.log("Datos recibidos:", this.resultado);
      },
      error: (error) => {
        this.errorMessage = error.message; // Muestra el mensaje de error al usuario
        //console.error("Error en el componente:", error); // Registro del error en el componente
      }
    });
  }

  onChangeYear(event: any){
    //this.planificacion();
    console.log(event.target.value)
    this.selectedYear = event.target.value;
    this.planificacion(this.user.id_institucional.toString()!, event.target.value);
  }

  getFullYear() {
    var date = new Date();
    const year = date.getFullYear()
    this.selectedYear = year
    //this.selectedYear = year+1
    this.years = [year-1, year, year+1]
    //this.years = [2025]
  }

  programar(){
    this.isProgramacion = true
  }

  volver(value: boolean) {
    this.isProgramacion = false;
    this.planificacion(this.user.id_institucional.toString()!, this.selectedYear.toString());
  }

}
